import "./Login.css";
import { updateAuth } from "../../Redux/AuthSlice";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { API } from "../../Utility/API";
import { useSelector } from "react-redux";
import { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import logo from "../../Assets/Images/logo.png";
export default function Forgotpassword() {
  const [uid, setuid] = useState("");

  const Forgotpassword_API = async (e) => {
    try {
      let responce = await API?.post(`/ForgetPassword?uid=${uid}`);
     
      responce =responce.data.data;
      console.log("responce", responce);
      if(responce=='Password sent to Email Id'){
        toast.success("Password sent to Email Id");
       // window.location.reload();
      }
      else{
        toast.error("Invalid User Id");
      }
      
    } catch (e) {
      console.log("Error While calling dashboard API", e);
    }
  };

  return (
    <>
      <div className="container-fluid loginpage vh-100">
        <div className="row h-100 align-items-center">
          <div className="col-md-4 col-sm-6 col-12 h-100 d-flex justify-content-center align-items-center h-100 flex-column  mx-auto mt-4 mt-sm-0">
            <div className="mt-5 mt-sm-0">
              <div className="card cardlogin position-relative mt-5 mt-sm-0">
                <div className="card-body p-0">
                  <div className="row mx-0 gy-2 h-100 g-3 ">
                    <div className="col-12">
                    <div className="loginheading text-center">
                       <img src={logo}/>
                      </div>
                      <div className="loginheading text-center">
                        Forgot Password?
                      </div>
                      {/* <div className="loginheading2 text-center text-capitalize fs-5">
                        You can reset your password here.
                      </div> */}
                    </div>
                    <div className="col-12">
                      <label htmlFor="userInput">Please Enter User Id</label>
                      <input
                        type="text"
                        className="control-form"
                        id="userInput"
                        placeholder="Enter Your User ID"
                        maxLength={6}
                        onChange={(e) => setuid(e.target.value)}
                      />
                    </div>

                    <div className="col-6">
                      <button className="btn logibtn newcolor px-4" onClick={()=>Forgotpassword_API()}>
                        {" "}
                        Reset Passwoard{" "}
                      </button>
                      </div>
                      <div className="col-6">
                      <button className="borde">
                      <Link
                                                className="Anker btn btn-theme1 logibtn  px-5"
                                                to="/login">
                                                Login
                                              </Link>
                                              </button>
                    </div>
                    <div className="col-12">
                      <div className="bottomtext">
                        Copyright © 2024. All Rights Reserved.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
